import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCashRegister, faRightFromBracket, faUsers, faCartFlatbed, faArrowsToCircle, faServer } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { getLangPrefix } from '../../../../helpers/helpers';
import { saveTokenInCookies } from '../../../../helpers/navbarHelpers';
import { WAVEUM_LOGIN } from '../../../../utils/constants/service';
import { BACKOFFICE_BASE_URL } from '../../../../utils/constants/navbarPaths';
import logo from '../../../../assets/img/waveum-navbar-logo.png'
import i18next from 'i18next';
import './sidebar.scss'

const OldLoginSidebar = ({
  userBrandApp,
  brandApp,
  logoutStart
}) => {

  const navbarItems = [
    {
      ids: { 26: true, 5: true}, label: i18next.t("storeLabels.storeUI"), colored: "#153b5e", icon: faCashRegister, path: ''
    },
    {
      ids: { 9: true }, label: i18next.t("storeLabels.wholesaleUI"), colored: "#770737", icon: faCartFlatbed, path: ''
    },
    {
      ids: { 22: true }, label: i18next.t("storeLabels.marketplaceUI"), colored: "#00A36C", icon: faArrowsToCircle, path: ''
    },
    {
      ids: { 12: true }, active: true, label: i18next.t("storeLabels.partnerUI"), colored: "#CC5500", icon: faUsers, path: ''
    },
    {
      ids: { 25: true }, label: i18next.t("storeLabels.backOffice"), colored: "#7393B3", icon: faServer, path: ''
    }
  ]

  const changeActiveMenu = (id: number) => {
    if (id === -1) return;
    const token = sessionStorage.privateToken;
    saveTokenInCookies(id, token);
  }

  const logoutAllStores = () => {
    logoutStart();
    window.open(`${WAVEUM_LOGIN}${getLangPrefix()}`, "_self");
  }

  const openBackOffice = () => {
    window.open(`${BACKOFFICE_BASE_URL}`, "_self");
  }

  return (
    <div className="navbarContainer">
      <Link
        to={getLangPrefix()}
        className="logoContainer"
      >
        <img
          src={logo}
          alt="head-logo"
        />
      </Link>
      <div className="storeIconsContainer">
        {navbarItems.map((item, idx) => {
          const foundItem = Object.keys(item.ids).find(key => (userBrandApp || []).some(it => +key === it.brandApp));
          return <div
            className={`storeIconItem ${!!foundItem ? 'active' : 'inactive'} ${!!item.active ? 'hovered' : ''}`}
            key={idx}
            onClick={() => changeActiveMenu(foundItem ? +foundItem : -1)}
          >
            <FontAwesomeIcon
              color="#153B5E"
              size='2x'
              icon={item.icon}
            />
            <span>{item.label}</span>
          </div>
        })}
        {/* <div
          className={`storeIconItem active`}
          onClick={() => changeActiveMenu(item.id)}
        >
          <FontAwesomeIcon
            color='#153B5E'
            size='2x'
            icon={faServer}
          />
          <span>{i18next.t("storeLabels.backOffice")}</span>
        </div> */}
      </div>
      <div className='to-bottom'>
        <div
          className="storeIconItem active"
          onClick={logoutAllStores}
        >
          <FontAwesomeIcon
            color='#153c5d'
            size='2x'
            icon={faRightFromBracket}
          />
          <span>{i18next.t('Terminal.dashboards.logoutAll')}</span>
        </div>
      </div>
    </div>
  )
}

export default OldLoginSidebar;